<template>
    <layout-sidebar>
        <div id="order-manage">
            <router-view></router-view>
        </div>
    </layout-sidebar>
</template>

<script>
    export default {
        name: "order-sync"
    }
</script>

<style lang="scss">


</style>